import React, { useState, useEffect, useMemo, useContext, useRef } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import MUIDataTable from "components/mui-datatable";
import { createTheme, ThemeProvider, StyledEngineProvider, adaptV4Theme } from '@mui/material/styles';
import EmployeeDetailMenu from "components/Menu/EmployeeDetailMenu"
import BulkActionsDropdown from "components/Content/Dropdown/BulkActionsDropdown"
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls"
import LoaderAnimation from "pages/LoaderAnimation";

import { Grow, TextField, IconButton, Tooltip } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import moment from "moment";
import AximTooltip from "components/AximTooltip";

import { Utils } from "common/Utils";
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import ModalStyles from "components/Content/Modal/ModalStyles.module.css";
import EmployeeProfile from "area/employer/EmployeeCensus/EmployeeProfile";
import * as Yup from 'yup';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Checkbox, Grid, FormControl, Input, Badge } from "@mui/material";

function EmployeeDashboard() {
  const profileRef = useRef({});
  const [openProfileModal, setOpenProfileModal] = useState(false);
  const [profileErrors, setProfileErrors] = useState({});
  const { companyId, userInfo } = useContext(PrivateRoutesContext);
  const [namesData, setNamesData] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [states, setStates] = useState([]);
  const [employmentStatus, setEmploymentStatus] = useState([]);
  const [employeeGroups, setEmployeeGroups] = useState([]);
  const [maritalStatuses, setMaritalStatuses] = useState([]);
  const emptyEmployee = {
    "Action": "New",
    "ChangeType": "New",
    "employeeID": "00000000-0000-0000-0000-000000000000",
    "companyID": "00000000-0000-0000-0000-000000000000",
    "insuredID": "00000000-0000-0000-0000-000000000000",
    "firstName": "",
    "lastName": "",
    "userName": null,
    "ssn": "",
    "emailAddress": null,
    "status": null,
    "contract": null,
    "classification": null,
    "serviceFee": 0,
    "dateCreated": null,
    "effectiveDateOfChange": null,
    "beginDate": null,
    "endDate": null,
    "changeDate": null,
    "prevBeginDate": "0001-01-01T00:00:00",
    "prevEndDate": "0001-01-01T00:00:00",
    "employeeGroupID": null,
    "hourlySalary": 0,
    "weeklySalary": 0,
    "annualSalary": 0,
    "employeeAltKey": null,
    "jobTitle": null,
    "locationCode": null,
    "hireDate": null,
    "rehireDate": null,
    "termDate": null,
    "serviceCreditDate": "0001-01-01T00:00:00",
    "employmentStatusID": null,
    "employeeNotes": null,
    "location": null,
    "division": null,
    "department": null,
    "jobClass": null,
    "importFileID": "00000000-0000-0000-0000-000000000000",
    "employmentStatusName": null,
    "companyName": null,
    "companyCode": null,
    "jobsiteID": "00000000-0000-0000-0000-000000000000",
    "jobsiteName": null,
    "jobsiteCode": null,
    "payCalendarID": "00000000-0000-0000-0000-000000000000",
    "payCalendarName": null,
    "payCalendarCode": null,
    "benefitPackageID": "00000000-0000-0000-0000-000000000000",
    "benefitPackageName": null,
    "benefitPackageCode": null,
    "benefitClassID": "00000000-0000-0000-0000-000000000000",
    "benefitClassName": null,
    "benefitClassCode": null,
    "groupServiceFee": 0,
    "classServiceFee": 0,
    "effectiveDate": null,
    "birthDate": null,
    "email": "",
    "contractCode": null,
    "contractFringeRate": 0,
    "loginName": null,
    "employeeGroupCode": null,
    "isActiveConfigurationRow": true,
    "benefitEnrollments": [],
    "birthDateStr": "",
    "termDateStr": "",
    "hireDateStr": "",
    "genderID": 0,
    "maritalStatusID": 0,
    "mailingAddress1": null,
    "mailingAddress2": null,
    "mailingStateID": null,
    "mailingCity": null,
    "mailingZipCode": null,
    "homePhone": null,
    "workPhone": null
  };

  const [newEmployeeProfileData, setNewEmployeeProfileData] = React.useState(emptyEmployee)
  const [genders, setGenders] = useState([]);

  const fetchStates = () => {
    apiGet(apiUrls.getStates()).then(
      (lovResponse) => {
        let lovResponseData = lovResponse.data;
        console.log(lovResponseData, "fetchStates");
        setStates(lovResponse.data)
      }
    )
  }

  const fetchEmploymentStatus = () => {
    apiGet(apiUrls.getEmploymentStatuses()).then(
      (lovResponse) => {
        let lovResponseData = lovResponse.data;
        console.log(lovResponseData, "fetchEmploymentStatus");
        setEmploymentStatus(lovResponse.data)
      }
    )
  }

  const fetchEmployeeGroups = () => {
    const selectedCompany = localStorage.getItem(`selectedCompanyId`);
    apiGet(apiUrls.getEmployeeGroups(selectedCompany)).then(
      (lovResponse) => {
        let lovResponseData = lovResponse.data;
        console.log(lovResponseData, "fetchEmployeeGroups");
        setEmployeeGroups(lovResponse.data)
      }
    )
  }

  const fetchMaritalStatuses = () => {
    apiGet(apiUrls.getMaritalStatuses()).then(
      (lovResponse) => {
        let lovResponseData = lovResponse.data;
        console.log(lovResponseData, "fetchMaritalStatuses");
        setMaritalStatuses(lovResponse.data)
      }
    )
  }

  const fetchGenders = () => {
    apiGet(apiUrls.getGenders()).then(
      (lovResponse) => {
        let lovResponseData = lovResponse.data;
        console.log(lovResponseData, "fetchGenders");
        setGenders(lovResponse.data)
      }
    )
  }

  const selectedRows = useMemo(
    () => namesData.map((index) => fetchedData[index]),
    [namesData]
  );


  const [thisRowSelected, setThisRowSelected] = useState();

  const rowIsSelected = (rowData) => {
    setThisRowSelected(rowData[0]);
  };

  const handleProfileClose = () => {
    setOpenProfileModal(false);
  }
  useEffect(() => {
    handleChangeCompany()
  }, [companyId]);

  useEffect(() => {
    fetchStates()
    fetchEmploymentStatus()
    fetchEmployeeGroups()
    fetchMaritalStatuses()
    fetchGenders()
  }, []);

  const canDownloadAndEdit = useMemo(() => {
    return !Utils.isBroker(userInfo);
  }, [userInfo]);

  const columns = [
    {
      name: "employeeID",
      label: "",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
      }
    },
    {
      name: "menu",
      label: " ",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
      }
    },
    "First Name",
    "Last Name",
    "Username",
    "SSN",
    "Email",
    "Status",
    "Contract",
    "Classification",
    "Date Created",
  ];

  const options = {
    filter: true,
    filterType: "dropdown",
    selectableRows: "multiple",
    rowsSelected: namesData,
    onRowClick: rowIsSelected,
    onRowSelectionChange: (rowsSelectedData, allRows, rowsSelected) => {
      setNamesData(rowsSelected);
    },
    responsive: "standard",
    viewColumns: true,
    download: canDownloadAndEdit,
    print: false,
    downloadOptions: {
      filename: "ActiveEmployeeList.csv",
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
    customToolbarSelect: () => {
      return <BulkActionsDropdown data={selectedRows} />;
    },
    textLabels: {
      body: {
        noMatch:
          isLoading ? (
            <LoaderAnimation />
          ) : (
            "No data to display"
          ),
      },
    },
    searchProps: { variant: "standard" },
    selectToolbarPlacement: "below"
  };

  const handleChangeCompany = () => {
    setIsLoading(true);
    apiGet(apiUrls.getEmployees(companyId)).then((response) => {
      setFetchedData(response.data);
      setIsLoading(false);
    })
      .catch(e => {
        console.log(e);
      });
  }

  const getMuiTheme = () => createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#f16824',
        contrastText: 'black',
      },
      secondary: {
        main: '#03049b',
      },
    },
    components: {
      MUIDataTableToolbarSelect: {
        styleOverrides: {
          title: {
            fontWeight: 600,
          }
        }
      },
    },
  });

  const CustomTooltip = ({ children, ...props }) => {
    return (
      <AximTooltip
        {...props}
      >
        {children}
      </AximTooltip>
    );
  }

  const handleAddEmployee = () => {
    const selectedCompany = localStorage.getItem(`selectedCompanyId`);
    setProfileErrors({});
    setOpenProfileModal(true);
  }

  const keysChangeCase = (j, toUpper = true) => {
    if (typeof j === 'string') { // so it works for javascript arrays as well
      try {
        j = JSON.parse(j);
      } catch (err) {
        console.error('Invalid JSON input');
        console.error(err);
      }
    }
    if (Array.isArray(j)) {
      console.log('is array?')
      if (j.length == 0) {
        return [];
      }
      return j.map(o => keysChangeCase(o, toUpper));
    }
    else {
      let newObj = Object.fromEntries(
        Object.entries(j).map(([k, v]) => [(toUpper ? k.charAt(0).toUpperCase() : k.charAt(0).toLowerCase()) + k.slice(1), v])
      );
      return newObj;
    }
  }
  const handleSaveEmployeeProfile = async () => {
    const selectedCompany = localStorage.getItem(`selectedCompanyId`);
    console.log(profileRef, 'profileRef')
    if (profileRef != null && profileRef.current.formData !== undefined) {
      let formData = profileRef.current.formData;

      console.log(formData, 'handleSaveEmployeeProfile formData');
      const newProfile = {
        "companyID": selectedCompany,
        "birthDate": formData.birthDate,
        "email": formData.email,
        "firstName": formData.firstName,
        "genderID": formData.genderID,
        "insuredID": formData.insuredID,
        "lastName": formData.lastName,
        "mailingAddress1": formData.mailingAddress1,
        "mailingAddress2": formData.mailingAddress2,
        "mailingCity": formData.mailingCity,
        "mailingStateID": formData.mailingStateID,
        "mailingZipCode": formData.mailingZipCode,
        "maritalStatusID": formData.maritalStatusID,
        "middleName": formData.middleName,
        "ssn": formData.ssn,
        "workPhone": formData.workPhone,
        "homePhone": formData.homePhone,
        "beginDate": formData.hireDate,
        "hireDate": formData.hireDate,
        "endDate": formData.EndDate,
        "changeDate": Utils.convertToDatePickerDefaultToday(),
        "employeeGroupID": formData.employeeGroupID,
        "hourlySalary": formData.hourlySalary,
        "weeklySalary": formData.weeklySalary,
        "annualSalary": formData.annualSalary,
        "employeeAltKey": formData.employeeAltKey,
        "jobTitle": formData.jobTitle,
        "locationCode": formData.locationCode,
        "hireDate": formData.hireDate,
        "employmentStatusID": formData.employmentStatusID,
        "employeeNotes": formData.employeeNotes,
        "jobsiteID": formData.jobsiteID,
        "effectiveDate": formData.hireDate,
      };

      const profileValidationSchema = Yup.object().shape({
        firstName: Yup.string().required('First Name is required')
          .max(50, 'First Name must not exceed 50 characters'),
        lastName: Yup.string().required('Last Name is required')
          .max(50, 'Last Name must not exceed 50 characters'),
        ssn: Yup.string().required('SSN is required')
          .max(11, 'SSN must not exceed 10 characters')
          .required(),
        birthDate: Yup.date().min('1901-01-01').typeError('Birth date is required'),
        email: Yup.string().email().required(),
        employeeGroupID: Yup.mixed().required('Employee group is required'),
        employmentStatusID: Yup.mixed().required('status is required'),
        hireDate: Yup.mixed().required('Hire date is required'),
        
      });

      try {
        const valid = await profileValidationSchema.validateSync(newProfile,
          { abortEarly: false }
        );

        apiPost(apiUrls.addEmployee(), keysChangeCase(newProfile, true))
          .then((response) => {
            console.log(response, 'add employee response')
            //   if (response.data != null && response.data.censusManagementID) {
            //     setCensusManagementID(response.data.censusManagementID)
            //   }
            //   else {
            //     setSaving(false);
            //   }

          })
          .catch((e) => {
            console.log(e, "CATCHED");
          })
          .finally(() => {
            //setSaving(false);
          });;

        console.log(valid, 'valid')
        //handleProfileSave(formData.employeeID, newProfile)

      } catch (error) {
        // error.inner
        console.log(error, 'valid error')
        let pErrors = {};
        for (const err of error.inner) {
          if (err.path) {
            console.log(err.path, 'err.path')
            console.log(err.message, 'err.message')
            Object.defineProperty(pErrors, err.path, {
              value: err.message,
              writable: true
            });
            //pErrors[error.path] = error.message;
          }
        }

        console.dir(pErrors, 'pErrors')
        setProfileErrors(pErrors)
      }
    }
  }


  return (
    <><div className={`${ButtonStyle.buttonWrapper} ${ButtonStyle.uploadFileWrapper}`}>
      <div className="pull-left">
        <Button
          variant="outlined"
          className={ButtonStyle.CsubmitBtn}
          style={{ marginRight: "15px" }}
          onClick={handleAddEmployee}
        >
          Add Employee
        </Button>
      </div>
    </div>
      <div className={TableStyle.tableWrapper}>
        {/* <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={getMuiTheme()} > */}
        <MUIDataTable
          title={"Active Employee list"}
          data={
            fetchedData &&
            fetchedData.map((item) => {
              return [
                item.employeeID,
                <EmployeeDetailMenu employeeId={item.employeeID} canEdit={canDownloadAndEdit} 
                reloadEmployees={handleChangeCompany}/>,
                item.firstName,
                item.lastName,
                item.userName === null ? "N/A" : item.userName,
                item.ssn,
                item.emailAddress,
                item.status,
                item.contract,
                item.classification,
                moment(item.dateCreated).calendar(),
              ];
            })
          }
          columns={columns}
          options={options}
          className="custom-mui-tabel"
          components={{
            Tooltip: CustomTooltip
          }}
        />
        {/* </ThemeProvider>
                    </StyledEngineProvider> */}
      </div>

      <Dialog
        open={openProfileModal}
        onClose={handleProfileClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={ModalStyles.empDataModal}
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">
          Add Employee
        </DialogTitle>
        <DialogContent className={ModalStyles.CustomTabsWrapper}>

          <form noValidate autoComplete="off" className="grid">
            <EmployeeProfile fetchedData={newEmployeeProfileData} ref={profileRef} states={states}
              maritalStatuses={maritalStatuses}
              genders={genders}
              employmentStatus={employmentStatus}
              employeeGroups={employeeGroups}
              errors={profileErrors}
              ></EmployeeProfile>
          </form>
        </DialogContent>
        <DialogActions className={ButtonStyle.buttonWrapper}>
          <Button
            variant="outlined"
            onClick={handleSaveEmployeeProfile}
            className={ButtonStyle.CsubmitBtn}
          >
            Save
          </Button>

          <Button
            variant="outlined"
            color="secondary"
            onClick={handleProfileClose}
            className={ButtonStyle.CcancelBtn}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default EmployeeDashboard;
